import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import {
  Box,
  Checkbox,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

const LocationsForm = ({ locations, onAdd, onRemove, selectableLocations }) => {
  // prettier-ignore
  const handleChange = R.ifElse(
    R.includes(R.__, locations),
    onRemove,
    onAdd
  );

  return (
    <>
      <Box pb={3}>
        <Box>
          <Typography sx={{ mb: 2, px: 3 }}>
            {R.isEmpty(selectableLocations) ? 'No Locations Available' : 'Available Locations'}
          </Typography>
        </Box>
        {selectableLocations.map(selectableLocation => {
          const labelId = `checkbox-list-label-${selectableLocation.locationId}`;
          return (
            <Fragment key={selectableLocation.locationId}>
              <ListItem disablePadding key={selectableLocation.locationId}>
                <ListItemButton
                  dense
                  onClick={() => handleChange(selectableLocation)}
                  sx={{ px: 3 }}
                >
                  <Checkbox
                    checked={R.includes(selectableLocation, locations)}
                    disableRipple
                    edge="start"
                    tabIndex={-1}
                  />
                  <ListItemText id={labelId} primary={selectableLocation.name} />
                </ListItemButton>
              </ListItem>
              <Divider />
            </Fragment>
          );
        })}
      </Box>
    </>
  );
};

LocationsForm.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  selectableLocations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default LocationsForm;
